export const EGGSHELL = "#FDFCFC";

export const pageColors = {
  default: EGGSHELL,
  white: "white",
};
